<template>
  <div class="warp">
    <fn-head :MenuStatus="MenuStatus"></fn-head>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>
<script>
import eventBus from "@/pages/EventBus";
import FnHead from "@/components/FnHead.vue";

export default {
  components: {
    FnHead
  },
  data() {
    return {
      MenuStatus: true
    };
  },
  activated() {},
  watch: {},
  created() {
    eventBus.$on("MenuStatus", (val) => {
      this.MenuStatus = val;
    });
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
